import { render } from "./site.vue?vue&type=template&id=28cf5e13&scoped=true&ts=true"
import script from "./site.vue?vue&type=script&lang=ts"
export * from "./site.vue?vue&type=script&lang=ts"

import "./site.vue?vue&type=style&index=0&id=28cf5e13&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28cf5e13"]])

export default __exports__